import React from "react";
const ModalBody = props => <div className="clearfix">{props.bodyContent}</div>;
export default ModalBody;
